import { apiRequest } from './http';
import type { AuthMeResponse, ClientPrincipal, UserInfo } from './types';

const authMePath = '/.auth/me';
const logoutPath = '/.auth/logout';

function getNameClaim(principal: ClientPrincipal): string | undefined {
  return principal.claims?.find(
    (claim) =>
      claim.typ === 'name' ||
      claim.typ === 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name' ||
      claim.typ === 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'
  )?.val;
}

export function normalizeClientPrincipal(principal: ClientPrincipal | null): UserInfo | null {
  if (!principal) return null;

  return {
    name: getNameClaim(principal) ?? principal.userDetails,
    userDetails: principal.userDetails,
    userRoles: principal.userRoles ?? [],
    identityProvider: principal.identityProvider
  };
}

export async function getCurrentUser(): Promise<UserInfo | null> {
  const response = await apiRequest<AuthMeResponse>(authMePath);
  return normalizeClientPrincipal(response.clientPrincipal);
}

export function logout(): void {
  // Dev-only shim: with the SWA CLI the auth cookie is set by JavaScript
  // (see oidc-callback.js), so it can be cleared here. In production the
  // StaticWebAppsAuthCookie is HttpOnly and this line is a harmless no-op —
  // the /.auth/logout redirect below is what actually ends the session.
  document.cookie = 'StaticWebAppsAuthCookie=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  window.location.href = logoutPath;
}
